import extend from 'lodash/extend';
// import objectPrefix from '../lib/objectPrefix';
// const prefix = objectPrefix();

module.exports = extend(
    // require('./partials/startFrame'),
    require('./partials/slotMachine'),
    require('./partials/dadPump'),
    require('./partials/funnelPipe'),
    require('./partials/guillotine'),
    require('./partials/blob'),
    require('./general/tiles'),
    // require('./general/faces'),
    // require('./partials/blob'),
    // require('./partials/title'),
    // require('./partials/endFrame'),
    // require('./partials/conclusion'),

    // require('./titles/toobig'),
    // {
    //     charlesTitle: {
    //         type: 'movieclip',
    //         // texture: [
    //         //     '/img/scenes/toobig/charles/charles-0.png',
    //         //     '/img/scenes/toobig/charles/charles-1.png',
    //         //     '/img/scenes/toobig/charles/charles-2.png',
    //         //     '/img/scenes/toobig/charles/charles-3.png',
    //         //     '/img/scenes/toobig/charles/charles-4.png'
    //         // ],
    //         texture: `sprite:/img/scenes/toobig/toobig-${prefix}.json,charles/`,
    //         scale: {
    //             x: '100%',
    //         },
    //         position: {
    //             x: '0%',
    //             y: '3%',
    //         },
    //     },
    //
    //     pipesTitle: {
    //         texture: '/img/scenes/toobig/pipes.png',
    //         scale: {
    //             x: '100%',
    //         },
    //     },
    //
    //     toobigTitle: {
    //         texture: 'sprite:/img/partials/scene-selector.json,scene-selector-sprite/toobig-title.png',
    //     },
    //
    //     toobigTitleFr: {
    //         texture: 'sprite:/img/partials/scene-selector.json,scene-selector-sprite/toobig-title-fr.png',
    //     },
    // },
);



// WEBPACK FOOTER //
// ./js/objects/toobig.js